import React, { useEffect, useState } from 'react';
import '../../Css/Course.css';
import { useNavigate } from 'react-router-dom';
import { fetchCourseData, fetchSubjectData } from '../../Firebase/Course-fb';
import { filterData, sortData } from '../../Helper/Calculation';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeletonload from '../../Helper/Skeletonload';
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';
import Datanotfound from '../../Helper/Datanotfound';

const Course = () => {
  const [course, setCourse] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const {loading,setLoading} = useAccessCard();

  const handleToAllCourse = async (course_code) => {
    setLoading(true);
    // navigate('/all-course',{state:course_code})
    navigate(`/all-course/${course_code}`)
  };

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true)
      try {
        const data = await fetchCourseData();
        const sortedCourses = sortData(data.filter(course => course.willDisplay === true));
        setCourse(sortedCourses);
      } catch (error) {
        console.error("Error fetching course data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className='course_container'>
      <h2>Course</h2>
      <div className='course_inner_container'>
        {loading ? (
          <Skeletonload />
        ) : course.length > 0 ? (
          course.map((item, index) => (
            <div key={index} className='course_card subject' onClick={() => handleToAllCourse(item.course_code)}>
              <img className='course_card_img' src={item.course_image} alt="Course" />
              <div
                style={{ fontSize: "17px" }}
                className={`heading sub ${item.course_name.length > (isMobile ? 17 : 20) ? 'long-text' : ''}`}
              >
                <span>{item.course_name}</span>
              </div>
            </div>
          ))
        ) : (
          <Datanotfound />
        )}
      </div>
    </div>
  );
};

export default Course;
